import { render, staticRenderFns } from "./I18nCheckbox.vue?vue&type=template&id=3702c7c2&"
import script from "./I18nCheckbox.vue?vue&type=script&lang=js&"
export * from "./I18nCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./I18nCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports